import Tooltip from "@mui/material/Tooltip";
import { useSelector } from "react-redux";

/**
 * @param {string} month - The month to be converted in integer form
 * @returns The name of the month according to the specified language
 */

export function MonthName({ month, year = "" }) {
  const currentLocale = useSelector(({ theme }) => theme.locale);
  const arabicMonth = [
    "يناير",
    "فبراير",
    "مارس",
    "أبريل",
    "مايو",
    "يونيو",
    "يوليو",
    "أغسطس",
    "سبتمبر",
    "أكتوبر",
    "نوفمبر",
    "ديسمبر",
  ];
  const englishMonth = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  return (
    <>
    {(currentLocale == "en"
        ? englishMonth[month - 1]
        : arabicMonth[month - 1]) +
        " " +
        year}
    </>
      
  );
}
